module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('div', {
    staticClass: "view-wrapper service-page"
  }, [_c('div', {
    staticClass: "service-page__hero",
    style: ({
      backgroundImage: 'url(' + _vm.service.hero_image.url + ')'
    })
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "service-page__title"
  }, [_c('span', {
    staticClass: "service-page__title-main"
  }, [_vm._v(_vm._s(_vm.service.title))])]), _vm._v(" "), _c('div', {
    staticClass: "service-page__abstract",
    domProps: {
      "innerHTML": _vm._s(_vm.service.abstract)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "service-page__flex-content"
  }, [_c('c-flex-content', {
    attrs: {
      "content": _vm.service.flex_content
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('c-services-list')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ad692ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Service.vue
// module id = 256
// module chunks = 0